import React, { useState } from 'react';
import { BringzzButton, BringzzImage, BringzzText, BringzzModal } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import {
  BringzzPageContainer,
  BringzzIcon,
} from "@bringzz/components";
import WAVE_IMAGE from 'assets/images/wave.png'
import { checkNotificationPermission, requestNotificationPermission } from 'notifications';
import useRequest from 'hooks/useRequest';
import { useTranslation } from 'react-i18next';

const AllowNotificationPage = () => {
  const { backPress, navigate } = useNavigation();
  const { sendRequest, loading } = useRequest();
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const handleEnableNotifications = async () => {
    try {
      const status = await requestNotificationPermission();
      if (!status) return;

      const response = await sendRequest({
        method: 'POST',
        url: '/module/user/toggleNotifications',
        data: { enable: true }
      });

      if (response?.status === 'success') {
        navigate('/register/whatsapp');
      } else {
        alert(t('component.auth.consumer.notification.errors.update_failed'));
      }
    } catch (error) {
      console.error('Notification error:', error);
      alert(t('component.auth.consumer.notification.errors.general_error'));
    }
  };

  return (
    <>
      <BringzzPageContainer
        className="bg-white relative"
        steps={true}
        activeStep={5}
        header={{
          left: (
            <BringzzIcon
              size='22'
              icon='IconChevronLeft'
              folder='LineIcons'
              className='cursor-pointer'
              onClick={backPress}
            />
          ),
          title: t('component.auth.consumer.notification.header.title'),
          right: <BringzzButton 
            size='sm' 
            className="border border-black" 
            onClick={() => navigate('/register/whatsapp')}
          >
            {t('component.auth.consumer.notification.header.skip')}
          </BringzzButton>
        }}
        footer={
          <div className='pb-8 px-6'>
            <BringzzButton
              size='lg'
              className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
              onClick={() => setShowModal(true)}
              disabled={loading}
            >
              {t('component.auth.consumer.notification.buttons.turn_on')}
            </BringzzButton>
          </div>
        }
        authenticated={false}
      >
        <div className='relative flex justify-center bg-magic-lilac/20'>
          <div className='relative bg-white w-full bg-cover bg-center flex flex-col'>
            <div className='flex-grow flex flex-col py-8 px-4'>
              <div className='z-0 flex flex-col'>
                <div className='pl-2 flex flex-col space-y-6 md:max-w-lg lg:max-w-xl xl:max-w-2xl'>
                  <BringzzText tag='h1' className='pl-2 text-midnight-blue font-bold'>
                    {t('component.auth.consumer.notification.title')}
                  </BringzzText>
                  <BringzzText tag="h5" className="font-normal">
                    {t('component.auth.consumer.notification.subtitle')}
                  </BringzzText>
                </div>
                <BringzzImage className='p-8 mt-4 z-0' src={WAVE_IMAGE} />
              </div>
            </div>
          </div>
        </div>
      </BringzzPageContainer>

      {showModal && (
        <BringzzModal
          title={t('component.auth.consumer.notification.modal.title')}
          description={t('component.auth.consumer.notification.modal.description')}
          onCancel={() => setShowModal(false)}
          onConfirm={async () => {
            try {
              await handleEnableNotifications();
            } finally {
              setShowModal(false);
            }
          }}
          confirmButtonText={loading ? t('component.auth.consumer.notification.modal.updating') : t('component.auth.consumer.notification.modal.allow')}
          confirmButtonDisabled={loading}
          className="z-50"
        />
      )}
    </>
  );
};

export default AllowNotificationPage;